import ExtendedButton from './ExtendedButton';

export default ExtendedButton;
